import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppStore from '../../store/AppStore'
import AdministrationAction from '../../administration/actions/AdministrationAction'
import { connect } from 'react-redux'
import { isEqual, pullAt } from 'lodash'
import DtoWatershed from '../../referential/dto/DtoWatershed'
import SitesAction from '../../sites/actions/SitesAction'
import DtoStation from '../../sites/dto/DtoStation'
import DtoFilterType from '../../referential/dto/DtoFilterType'
import ThemeDto from '../../administration/dto/ThemeDto'
import UUID from 'uuid'
import { getRgba } from '../../utils/ResearchTypesUtils'
import Chip from '@material-ui/core/Chip'
import { css } from 'glamor'

class AutoCompleteChips extends Component {

	constructor(props) {
		super(props)
	}

	shouldComponentUpdate(nextProps) {
		return !isEqual(this.props.selectedFilters, nextProps.selectedFilters)
	}

	onRequestDelete(index) {
		$('.tooltipped_chips').tooltip('remove')
		const tmp = this.props.selectedFilters.slice()
		pullAt(tmp, [index])
		AppStore.dispatch(AdministrationAction.selectedFilters(tmp))
		if (this.props.stations.length) {
			AppStore.dispatch(SitesAction.reset())
			AppStore.dispatch(SitesAction.fetchResearchTypes())
		}
	}

	getChips = () => {
		return this.props.selectedFilters.map((o, index) => {
			const rgba = (() => {
				if (o.type && o.type.color) {
					return getRgba(o.type.color, 1)
				}
				return getRgba('3, 169, 244')
			})()
			return (
				<div className='col chipsCol'>
					<Chip
						key={ index }
						label={ o.label }
						onDelete={ () => this.onRequestDelete(index) }
						{ ...css({ backgroundColor: rgba + ' !important', color: 'white !important' }) }
					/>
				</div>
			)
		})
	}

	render() {
		return (
			<div key={ UUID.v4() } className={ 'row no-margin' }>
				<div className='col s12 no-padding'>
					<div className={ 'row no-margin' }>
						{ this.getChips() }
					</div>
				</div>
			</div>
		)
	}

	componentDidUpdate() {
		$('.tooltipped_chips').tooltip({ delay: 20 })
	}

	componentDidMount() {
		$('.tooltipped_chips').tooltip({ delay: 20 })
	}

	componentWillUnmount() {
		$('.tooltipped_chips').tooltip('remove')
	}
}

AutoCompleteChips.propTypes = {
	selectedFilters: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.object
	})),
	filterEntry: PropTypes.string,
	stations: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation)),
	selectedThemes: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.instanceOf(ThemeDto)
	})),
	filterTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoFilterType)),
	themes: PropTypes.arrayOf(PropTypes.instanceOf(ThemeDto)),
	watershedSelected: PropTypes.arrayOf(PropTypes.instanceOf(DtoWatershed))
}
const mapStateToProps = store => {
	return {
		selectedFilters: store.AdministrationReducer.selectedFilters,
		filterEntry: store.AdministrationReducer.filterEntry,
		stations: store.SitesReducer.stations,
		filterTypes: store.ReferentialReducer.filterTypes,
		selectedThemes: store.AdministrationReducer.selectedThemes,
		themes: store.AdministrationReducer.themes,
		watershedSelected: store.SitesReducer.watershedSelected
	}
}
export default connect(mapStateToProps)(AutoCompleteChips)



// WEBPACK FOOTER //
// ./src/components/autocompleteChips/ChipsPanel.js